import "./SignUpModal.scss"
import close_icon from "../../trailerPlayers/modal_yt_player/images/close.png"
import { useEffect } from "react"


const SignUpModal =({
    iframeUrl, 
    setCloseIframe, 
    closeIframe,
    closePage,
    stopPropagationPopup,
    iframeTitle})=>{

    useEffect(()=>{
        setCloseIframe(false)
    },[closeIframe])
    

    return(
        <div className="preliminary-iframe" onClick={closePage}>
            <div className="iframe-contex" onClick={e => stopPropagationPopup(e)}>
                <div className="close-page">
                    <p>{iframeTitle}</p>
                    <img src={close_icon} alt="" onClick={closePage}/>
                </div>
                <iframe src={iframeUrl} className="iframe_style"></iframe>
            </div>
        </div>
    )
}

export default SignUpModal

